class FormulaireFiltre {
    constructor(){  
        this.formulaireChamp = document.querySelector('.change_valeur_form');
        this.formulaireChamp2 = document.querySelector('.change_valeur_form_2');
        this.formulaire = document.querySelector('#formulaire_filtre');
        this._init();
    }

    _init(){
        document.addEventListener('DOMContentLoaded', (event) => {
            if (this.formulaireChamp) {
                this.formulaireChamp.addEventListener('change', 
                    this._activeFiltre.bind(this),
                    false
                );
            }

            if (this.formulaireChamp2) {
                this.formulaireChamp2.addEventListener('change', 
                    this._activeFiltre2.bind(this),
                    false
                );
            }
        });
    }
    
    _activeFiltre(){
        //console.log(this.formulaireChamp.value);
        this.formulaire.submit();
        return false;
    }
    
    _activeFiltre2(){
        //console.log(this.formulaireChamp2.value);
        this.formulaire.submit();
        return false;
    }
}

export const formulaireFiltre = new FormulaireFiltre();